import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { API_URL } from '../apiBase';

const MaintenanceContext = createContext();

export const useMaintenance = () => {
  const context = useContext(MaintenanceContext);
  if (!context) {
    throw new Error('useMaintenance must be used within MaintenanceProvider');
  }
  return context;
};

export const MaintenanceProvider = ({ children }) => {
  const [maintenanceStatus, setMaintenanceStatus] = useState({
    is_active: false,
    reason: null,
    estimated_end: null,
    activated_by: null,
    activated_at: null,
    loading: true
  });

  const checkMaintenanceStatus = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/maintenance/status`);
      setMaintenanceStatus({
        ...response.data,
        loading: false
      });
    } catch (error) {
      console.error('Error checking maintenance status:', error);
      setMaintenanceStatus(prev => ({ ...prev, loading: false }));
    }
  };

  useEffect(() => {
    checkMaintenanceStatus();
    
    // Poll every 30 seconds to check maintenance status
    const interval = setInterval(checkMaintenanceStatus, 30000);
    
    return () => clearInterval(interval);
  }, []);

  const activateMaintenance = async (reason, estimatedEnd) => {
    try {
      const response = await axios.post(`${API_URL}/api/maintenance/activate`, {
        reason,
        estimated_end: estimatedEnd || null
      });
      
      await checkMaintenanceStatus();
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  const deactivateMaintenance = async () => {
    try {
      const response = await axios.post(`${API_URL}/api/maintenance/deactivate`);
      await checkMaintenanceStatus();
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  return (
    <MaintenanceContext.Provider
      value={{
        maintenanceStatus,
        activateMaintenance,
        deactivateMaintenance,
        checkMaintenanceStatus
      }}
    >
      {children}
    </MaintenanceContext.Provider>
  );
};
